<h2 class="emperor-ui-question-set-header">{{ name }}</h2>
